import React from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../constant/URL";
import styles from "./LoadPortFolio.module.css";

const LoadPortFolio = ({ data }) => {
  const { name, _id, primaryImage, price } = data;
  const navigate = useNavigate();

  const GoToDetails = (_id) => {
    const url = `/details/${_id}`;
    navigate(url);
    console.log(name);
  };
  return (
    <div className={styles.card}>
      <div className="">
        <div className="d-flex justify-content-center">
          <div
            className={styles.img_wrapper}
            style={{
              background: `url(${BASE_URL}/image/${primaryImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
            }}
          ></div>
        </div>
        <h3 className={styles.crd_title}>{name}</h3>
        <div className="d-flex justify-content-between align-items-center pb-3">
          <span className="d-block ">{price} BDT</span>
          {data.stock > 0 ? (
            <span className="text-success">In Stock</span>
          ) : (
            <span className="text-success">Out Of Stock</span>
          )}
        </div>
        <div
          className={`btn btn-block ${styles.btn_order}`}
          onClick={() => GoToDetails(_id)}
        >
          See Details
        </div>
      </div>
    </div>
  );
};

export default LoadPortFolio;
